import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { getRoleFallbackPath } from '@/config/routeAccess'

/** Rota curinga: home do papel se logado, senão login */
export function FallbackRedirect() {
  const { authReady, isAuthenticated, user } = useAuthStore()

  if (!authReady) {
    return (
      <div
        className='flex min-h-screen items-center justify-center bg-bg-primary'
        role='status'
        aria-label='Carregando'
      >
        <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return <Navigate to='/login' replace />
  }

  return <Navigate to={getRoleFallbackPath(user.role, undefined, user)} replace />
}
